
import { z } from "zod";
import { isFileReference } from "@/utils/temporaryFileStorage";

// Helper function to validate either FileList or FileReference
const fileOrReferenceValidation = (input: any) => {
  return isFileReference(input) || input instanceof FileList;
};

export const documentSectionSchema = z.object({
  country_code: z.string().min(2, "Please select a country"),
  document_type_id: z.string().min(1, "Please select an ID type"),
  document_number: z.string().min(1, "Please enter the document number"),
  issue_date: z.date().optional(),
  expiry_date: z.date().optional(),
  verification_purpose: z
    .enum(["primary", "expatriate", "both"])
    .default("primary"),
  document_file: z
    .any()
    .refine(fileOrReferenceValidation, "Please select a file")
    .refine((input) => {
      if (isFileReference(input)) {
        // Already validated by isFileReference
        return true;
      } else if (input instanceof FileList) {
        return input.length > 0;
      }
      return false;
    }, "Please select a file")
    .refine((input) => {
      if (isFileReference(input)) {
        // FileReference already has validated mime type
        return true;
      } else if (input instanceof FileList) {
        return ["image/jpeg", "image/png", "application/pdf"].includes(input[0]?.type);
      }
      return false;
    }, "Please upload a valid document (PDF, JPEG, or PNG)")
    .refine((input) => {
      if (isFileReference(input)) {
        return input.size <= 5 * 1024 * 1024;
      } else if (input instanceof FileList) {
        return input[0]?.size <= 5 * 1024 * 1024;
      }
      return false;
    }, "File size must be less than 5MB"),
});

export const formSchema = z.object({
  sections: z.array(documentSectionSchema),
});

export type DocumentSectionValues = z.infer<typeof documentSectionSchema>;
export type FormValues = z.infer<typeof formSchema>;
